import { useI18n } from "../../../hooks"

const defaultTranslations = {
  password: "Password",
  changePassword: "Change password",
  passwordHint: "Use a strong password and change it regularly to keep your account secure.",
  oldPassword: "Old password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  passwordsMustMatch: "Passwords must match",
  forgotPassword: "I forgot my password",
  requestLink: "send a link to reset password",
  cancel: "Cancel",
  sendResetPasswordLinkSuccessMessage: "A link to reset your password has been sent to your email.",
  sendLinkFailedMessage: "Failed to send a link!",
}

export const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations } = useI18n()

  const {
    password = defaults.password,
    changePassword = defaults.changePassword,
    passwordHint = defaults.passwordHint,
    oldPassword = defaults.oldPassword,
    newPassword = defaults.newPassword,
    confirmPassword = defaults.confirmPassword,
    passwordsMustMatch = defaults.passwordsMustMatch,
    forgotPassword = defaults.forgotPassword,
    requestLink = defaults.requestLink,
    cancel = defaults.cancel,
    sendResetPasswordLinkSuccessMessage = defaults.sendResetPasswordLinkSuccessMessage,
    sendLinkFailedMessage = defaults.sendLinkFailedMessage,
  } = translations

  return {
    password,
    changePassword,
    passwordHint,
    oldPassword,
    newPassword,
    confirmPassword,
    passwordsMustMatch,
    forgotPassword,
    requestLink,
    cancel,
    sendResetPasswordLinkSuccessMessage,
    sendLinkFailedMessage,
  }
}

type Translations = typeof defaultTranslations
